export default {
      id: "hand-move-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#hand-move",
      toString: function () {
        return this.url;
      }
    }